<template>
  <div id="busca-nome-plano">
    <span :class="classNome"> {{ nomePlano }}</span>
  </div>
</template>
<script>
export default {
  name: "busca-nome-plano",

  props:{
      idPlano: 0
  },

  data(){
    return{
    }
  },

  computed:{
    nomePlano(){
      switch(this.idPlano){
        case 1:
          return 'Grátis'
          breack;
        case 2:
          return  'Básico'
          breack;
        case 3:
           return  'Profissional'
           breack;
        case 4:
           return  'Premium'
           breack;
        default:
           return  ''
            breack;
      }//fim switch
    },//fim NomePlano

    classNome(){
        switch(this.idPlano){
          case 1:
            return 'text-primary'
            breack;
          case 2:
            return  'text-default'
            breack;
          case 3:
             return  'text-success'
             breack;
          case 4:
             return  'text-warning'
             breack;
          default:
             return  ''
              breack;
        }//fim switch
    }
  }//fim watch

}
</script>
<style lang="scss" scoped>
</style>
